// Created by jarongallo at 6/9/21
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_SERVICE_FOR_FIXED_FILES, GET_SERVICE_REQUEST_FIXED_FILES } from './queries';
import FullscreenFiles from '../../IndividualService/FullscreenFiles';
import { FULLSCREEN_TYPES } from '../../IndividualService/FullscreenFiles/config';
import UIMultiImageSelect from '../../../../../components/UI/UIMultiImageSelect';
import { TYPES } from '../../../../../components/UI/UIMultiImageSelect/config';
import PLUpload from '../../../../../components/PL/PLUpload';
import { FILE_STATUS_IN_PROGRESS, FILE_TYPE_IMAGE } from '../../../../../utils/Config/Constants';
import * as strings from './strings';

export default function ServiceRequestFixedFilesTab({ serviceRequestId }: ServiceRequestFixedFilesTabProps) {
	const [selectedCompletedFileIndex, setSelectedCompletedFileIndex] = useState<number>();
	const [serviceRequest, setServiceRequest] = useState<ServiceRequestType>();
	const [service, setService] = useState<ServiceType>();

	const [getServiceRequestService, { data: serviceRequestServiceData }] = useLazyQuery(GET_SERVICE_FOR_FIXED_FILES);

	const [getServiceRequest, { data: serviceRequestData }] = useLazyQuery(GET_SERVICE_REQUEST_FIXED_FILES, {
		variables: { id: serviceRequestId }
	});

	// Mark: Lifecycle functions

	useEffect(() => {
		(async () => {
			await getServiceRequest();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (serviceRequestData) {
				setServiceRequest(serviceRequestData.serviceRequest);
				let variables = { id: serviceRequestData.serviceRequest.service.id };
				await getServiceRequestService({ variables });
			}
		})();
	}, [serviceRequestData]);

	useEffect(() => {
		(() => {
			if (serviceRequestServiceData) {
				setService(serviceRequestServiceData.service);
			}
		})();
	}, [serviceRequestServiceData]);

	if (!serviceRequest) return null;

	const renderUpload = () => {
		return (
			<PLUpload
				multiple={true}
				postData={{ serviceRequestId: serviceRequest.id }}
				fileType={FILE_TYPE_IMAGE}
				onFileUploadComplete={getServiceRequest}
				uploadStatus={FILE_STATUS_IN_PROGRESS}
			/>
		);
	};

	const renderContent = () => {
		return (
			<UIMultiImageSelect
				emptySetTitle={strings.emptySetTitle}
				emptySetDescription={strings.emptySetDescription}
				type={TYPES.image}
				updateData={getServiceRequest}
				files={serviceRequest.completedFiles}
				disableSort={false}
				rightItem={renderUpload()}
			/>
		);
	};

	return (
		<div>
			{selectedCompletedFileIndex !== undefined && (
				<FullscreenFiles
					type={FULLSCREEN_TYPES.IMAGE_TYPE}
					updateService={() => getServiceRequest}
					initialSlide={selectedCompletedFileIndex}
					goBack={() => setSelectedCompletedFileIndex(undefined)}
					files={serviceRequest.completedFiles}
					service={service}
				/>
			)}
			{renderContent()}
		</div>
	);
}
